import Papa from "papaparse";
import { getDownloadURL, ref as storageRef } from "firebase/storage";
import { storage } from "../../../../helpers/firebaseConfig";

export async function fetchFirstCsv(paths, signal) {
  let lastError;
  for (const path of paths) {
    try {
      const url = await getDownloadURL(storageRef(storage, path));
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const csv = await response.text();
      return Papa.parse(csv, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header) => header.trim().replace(/^\uFEFF/, ""),
      }).data;
    } catch (error) {
      if (signal.aborted) throw error;
      lastError = error;
    }
  }
  throw lastError || new Error("No simulation summary file was found.");
}
